/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Proud_Late_Butterfly_FileInputs */

const fr_proud_late_butterfly_file = /** @type {(inputs: Proud_Late_Butterfly_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les stats de vues sur les 24 dernières heures (comparés aux 24h précédentes)`)
};

/**

* @param {Proud_Late_Butterfly_FileInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const proud_late_butterfly_file = /** @type {((inputs?: Proud_Late_Butterfly_FileInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Proud_Late_Butterfly_FileInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_proud_late_butterfly_file(inputs)
});